import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EditDocumentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EditDocumentSVG;
